import React, {FC} from 'react';
import {createPortal} from "react-dom";
import Loader from "../../components/ui-kit/cirlcles-loader/circles-loader";
import styles from './loader-portal.module.scss'

interface LoaderPortalProps {
    backgroundColor?: string;
}

const LoaderPortal: FC<LoaderPortalProps> = ({ backgroundColor = '#FAFAFA80' }) => {
    const loaderRoot = document.getElementById('loader-portal');
    if (!loaderRoot) return null;
    return createPortal(
        <div style={{backgroundColor: `${backgroundColor}`}} className={styles.loader}>
            <Loader/>
        </div>,
        loaderRoot
    );
};

export default LoaderPortal;